"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostWorkflowResponse = instanceOfApiPostWorkflowResponse;
exports.ApiPostWorkflowResponseFromJSON = ApiPostWorkflowResponseFromJSON;
exports.ApiPostWorkflowResponseFromJSONTyped = ApiPostWorkflowResponseFromJSONTyped;
exports.ApiPostWorkflowResponseToJSON = ApiPostWorkflowResponseToJSON;
exports.ApiPostWorkflowResponseToJSONTyped = ApiPostWorkflowResponseToJSONTyped;
/**
 * Check if a given object implements the ApiPostWorkflowResponse interface.
 */
function instanceOfApiPostWorkflowResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ApiPostWorkflowResponseFromJSON(json) {
    return ApiPostWorkflowResponseFromJSONTyped(json, false);
}
function ApiPostWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'success': json['success'],
        'message': json['message'],
    };
}
function ApiPostWorkflowResponseToJSON(json) {
    return ApiPostWorkflowResponseToJSONTyped(json, false);
}
function ApiPostWorkflowResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'success': value['success'],
        'message': value['message'],
    };
}
